import React, { useEffect, useState } from "react";
import { Flex, Spin, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { updateOrganization } from "../../redux/organizationSlice";
import SaveButton from "../../components/UI/savebutton";
import ZipCodeInput from "../../components/ServiceArea/ZipCodeInput";
import ZipCodeList from "../../components/ServiceArea/ZipCodeList";
import OutsideZoneConfig from "../../components/ServiceArea/OutsideZoneConfig";

const { Title } = Typography;

function ServiceArea() {
  const [zipCodesList, setZipCodesList] = useState([]);
  const [outsideZone, setOutsideZone] = useState({
    zipCodes: [],
    defaultMessage: "",
    showForMembers: false,
    rules: []
  });

  const { loading, organizationData } = useSelector((state) => state?.organization);
  const dispatch = useDispatch();

  useEffect(() => {
    setZipCodesList(organizationData?.zipCodes || []);
    setOutsideZone({
      zipCodes: organizationData?.outsideZone?.zipCodes || [],
      defaultMessage: organizationData?.outsideZone?.defaultMessage || null,
      showForMembers: organizationData?.outsideZone?.showForMembers || false,
      rules: organizationData?.outsideZone?.rules || []
    });
  }, [organizationData]);

  const onSubmit = (e) => {
    e.preventDefault();
    const data = {
      ...organizationData,
      zipCodes: zipCodesList,
      outsideZone: {
        zipCodes: outsideZone.zipCodes,
        defaultMessage: outsideZone.defaultMessage,
        showForMembers: outsideZone.showForMembers,
        rules: outsideZone.rules
      }
    };
    dispatch(updateOrganization({
      id: organizationData._id,
      payload: data,
      page: "Service Area"
    }));
  };

  return (
    <form style={{ width: "100%" }} onSubmit={onSubmit}>
      <Spin spinning={loading} fullscreen />

      <Flex align="center" gap={10} style={{ marginBottom: "20px" }}>
        <img
          src={require("../../assets/Images/map-logo.png")}
          height={20}
          width={20}
          alt="map-logo"
          style={{ verticalAlign: "middle", display: "inline-block" }}
        />
        <Title level={3} style={{ margin: 0, color: "black" }}>
          Service Area
        </Title>
      </Flex>

      <div className="bg-white shadow-md rounded-lg p-6 mb-6 flex flex-col gap-6 items-start w-full">
        <Flex align="center" gap={8}>
          <div style={{
            width: "8px",
            height: "8px",
            backgroundColor: "#52c41a",
            borderRadius: "50%"
          }} />
          <Title level={5} style={{ margin: 0, color: "#262626" }}>
            Primary Service Area
          </Title>
        </Flex>

        <ZipCodeInput
          zone="primary"
          zipCodesList={zipCodesList}
          setZipCodesList={setZipCodesList}
          outsideZone={outsideZone}
          setOutsideZone={setOutsideZone}
        />

        <ZipCodeList
          zone="primary"
          zipCodes={zipCodesList}
          onRemove={(zip) => setZipCodesList(zipCodesList.filter((e) => e !== zip))}
          onMove={(zip) => {
            setZipCodesList(zipCodesList.filter((e) => e !== zip));
            setOutsideZone({
              ...outsideZone,
              zipCodes: [...new Set([...outsideZone.zipCodes, zip])]
            });
          }}
        />
      </div>
      <OutsideZoneConfig
        outsideZone={outsideZone}
        setOutsideZone={setOutsideZone}
        zipCodesList={zipCodesList}
        setZipCodesList={setZipCodesList}
      />

      <SaveButton onSubmit={onSubmit} isDirty={true} />
    </form>
  );
}

export default ServiceArea;